import { AxiosHelper } from '@/modules/shared/infra/protocols/http';
import React from 'react';
import { FiDownload } from 'react-icons/fi';

import 'react-image-lightbox/style.css';

import ReactLightbox from 'react-image-lightbox';

import { LightboxMainProps } from './interfaces';

function fileNameFromUrl(url: string): string {
  try {
    const { pathname } = new URL(url);
    const segment = pathname.split('/').pop() ?? '';
    return decodeURIComponent(segment) || 'image';
  } catch {
    return 'image';
  }
}

async function downloadImage(url: string, fileName: string) {
  const base = AxiosHelper.getFullPath();
  const params = new URLSearchParams({ url, filename: fileName });
  const proxyUrl = `${base}v1/proxy_download?${params.toString()}`;

  const response = await fetch(proxyUrl, {
    headers: { Authorization: AxiosHelper.token ?? '' },
  });
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}

const Lightbox: React.FC<LightboxMainProps> = (props) => {
  const {
    images,
    fileNames,
    captions,
    onCloseRequest,
    onPreviousRequest,
    onNextRequest,
    currentIndex,
  } = props;

  const mainIdx = images[currentIndex];
  const nextIdx = images[(currentIndex + 1) % images.length];
  const previousIdx =
    images[(currentIndex + images.length - 1) % images.length];

  const currentFileName = fileNames?.[currentIndex] ?? fileNameFromUrl(mainIdx);

  const downloadButton = (
    <button
      key="download"
      type="button"
      title="Download"
      className="ril__toolbarItemChild ril__builtinButton"
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        marginRight: '-6px',
      }}
      onClick={() => downloadImage(mainIdx, currentFileName)}
    >
      <FiDownload size={22} color="white" />
    </button>
  );

  return (
    <ReactLightbox
      reactModalStyle={{
        overlay: {
          zIndex: 100000,
        },
        content: {
          zIndex: 900000,
          top: '50%',
          left: '50%',
          width: '100%',
          height: '100%',
        },
      }}
      mainSrc={mainIdx}
      nextSrc={nextIdx}
      prevSrc={previousIdx}
      imageCaption={captions?.[currentIndex]}
      onCloseRequest={onCloseRequest}
      onMovePrevRequest={onPreviousRequest}
      onMoveNextRequest={onNextRequest}
      toolbarButtons={[downloadButton]}
    />
  );
};

export default Lightbox;
